import { trackEvent } from '../../analytics';
import { SEMANTIC_EVENT_NAME, TOPIC_TAG_TXT, TRIGGER_LOCATION, TRIGGER_TYPE } from './globals';

// https://dataportal.zillowgroup.net/event-registry/7252
export const CONVERSATION_ITEM_CLICK_EVENT_TYPE_ID = '7252';
export const emitConversationItemClickEvent = () =>
  trackEvent({
    envelope: {
      event_type_id: CONVERSATION_ITEM_CLICK_EVENT_TYPE_ID,
      event_type_version_id: '1',
      event_template_id: '171',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: TRIGGER_LOCATION.RachelInbox,
      trigger_source_nm: 'button_to_open_conversation',
      trigger_object_nm: 'conversation_list',
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ViewMessage,
      topic_tag_txt: [TOPIC_TAG_TXT.RachelSatellite],
    },
  });
